import React, {Component} from 'react';
import Title from '../base/title';
import Dropdown from '../base/dropdown';
import moment from 'moment';
import api from '../../utils/api';
import _ from "lodash";

const ReactHighcharts = require('react-highcharts');

const months = [];
for (let i = 0; i < 24; i++) {
    months.push(moment().startOf('Y').add(i, 'M').format('MMM'));
}

const defaultConf = {
    title: {
        text: null
    },
    credits: {
        enabled: false
    },
    legend: {
        enabled: false
    },
    xAxis: {
        gridLineWidth: 1,
        categories: months
    },
    yAxis: [{
        min: -450,
        tickInterval: 150,
        allowDecimals: false,
        title: {
            text: "L4L"
        },
        labels: {
            format: '{value}%'
        }
    }, {
        min: -12,
        tickInterval: 4,
        allowDecimals: false,
        title: {
            text: "Diferenciales"
        },
        labels: {
            format: '{value}%'
        },
        opposite: true
    }],
    tooltip: {
        enabled: true
    },
    plotOptions: {
        series: {
            animation: false,
            marker: {
                enabled: false
            }
        }
    }
};

export default class Sensibility extends Component {

    constructor(props) {
        super(props);

        let otherStations = [{id: 0, label: ''}];
        let otherStation = otherStations[0];
        if(this.props.level === 'STATION'){
            let {data} = this.props;
            if(data.prime_marker){
                otherStations.push({id: data.prime_marker.id, label: `PM - ${data.prime_marker.brand.name} - ${data.prime_marker.address}`});
                otherStation = otherStations[1];
            }
            if(data.secondary_marker){
                otherStations.push({id: data.secondary_marker.id, label: `SM - ${data.secondary_marker.brand.name} - ${data.secondary_marker.address}`});
            }
            if(data.nearby_markets && data.nearby_markets.length > 0){
                data.nearby_markets.forEach(station => {
                    otherStations.push({id: station.id, label: `${station.brand.name} - ${station.address}`});
                })
            }
        }

        this.state = {
            opened: true,
            loader: ' loader-box',
            period: [{id: 0, label: ''}],
            products: [{id: 0, label: ''}],
            otherStations,
            month: {},
            product: {},
            otherStation,
            series: [],
            rows: [],
            chartAvailable: true
        };
        defaultConf.series = this.state.series;
        this.state.chart = defaultConf;
        this.getPeriod = this.getPeriod.bind(this);
        this.getProducts = this.getProducts.bind(this);
        this.getOtherStations = this.getOtherStations.bind(this);
        this.redraw = this.redraw.bind(this);
        this.loadChart = this.loadChart.bind(this);
    }

    calculateMinTickInterval = (data) =>{
        let maxs=[];
        let mins=[];
        let diferencialMaxs=[];
        let diferencialMins=[];

        data.series.forEach(serie =>{
            if(serie.yAxis===1){
                diferencialMaxs.push(Math.max.apply(Math, serie.data));
                diferencialMins.push(Math.min.apply(Math, serie.data));
            }else{
                maxs.push(Math.max.apply(Math, serie.data));
                mins.push(Math.min.apply(Math, serie.data));
            }
        });

        let minAbs= Math.abs(Math.min.apply(Math, mins));
        let maxAbs= Math.abs(Math.max.apply(Math, maxs));

        let diferencialMaxAbs = Math.abs(Math.max.apply(Math, diferencialMaxs));
        let diferencialMinAbs = Math.abs(Math.min.apply(Math, diferencialMins));

        let totalMax= _.round(Math.max(minAbs, maxAbs),-1);
        let totalDifMax= _.round(Math.max(diferencialMaxAbs,diferencialMinAbs),-1);
        if(totalDifMax < 5) totalDifMax = 10;

        let minFirstAxis = -totalMax;
        let minSecondAxis = -totalDifMax;

        let tickInterval= totalMax/2;
        let tickIntervalSecondAxis =  totalDifMax/2;

        let maxFirstAxis =  tickInterval*3;
        let maxSecondAxis =  tickIntervalSecondAxis*3;

        return {minFirstAxis, tickInterval, minSecondAxis, tickIntervalSecondAxis, maxFirstAxis, maxSecondAxis};
    };

    loadChart() {
        let _self = this;
        let GRAPH_URL = 'widgets/price-sensitivity/?id=' + this.props.data.id + '&type=' + this.props.level +
            '&product=' + this.state.product.id + '&time_reference=' + this.state.month.id;
        if(this.props.level === 'STATION' && this.state.otherStation && this.state.otherStation.id){
            GRAPH_URL = `${GRAPH_URL}&counterpart=${this.state.otherStation.id}`
        }
        api.get(GRAPH_URL, true).then(resp => {
            defaultConf.xAxis.categories = resp.data.categories;
            defaultConf.series = resp.data.series;
            let minTickInterval = this.calculateMinTickInterval(resp.data);

            defaultConf.yAxis[0].min= minTickInterval.minFirstAxis;
            defaultConf.yAxis[0].tickInterval = minTickInterval.tickInterval;
            defaultConf.yAxis[0].max = minTickInterval.maxFirstAxis;

            defaultConf.yAxis[1].min= minTickInterval.minSecondAxis;
            defaultConf.yAxis[1].tickInterval = minTickInterval.tickIntervalSecondAxis;
            defaultConf.yAxis[1].max= minTickInterval.maxSecondAxis;

            let rows = [];
            resp.data.raw.forEach(key => {
                rows.push({
                    label: key.name,
                    color: '#CCCCCC',
                    height: parseInt(Math.random() * 10, 10),
                    data: key.data
                });
            });

            _self.setState({
                loader: '',
                rows: rows,
                chartAvailable: true
            })
        });
    }

    componentDidMount() {
        let _self = this;
        api.get('filters/products').then(resp => {
            let products = [{id: 0, label: ''}];
            resp.data.forEach(prod => {
                products.push({id: prod.id, label: prod.short_name, active: true});
            });

            api.get('filters/time-range/?widget=price-sensitivity').then(resp => {
                let months = [{id: 0, label: "SELECCIONAR"}];
                resp.data.forEach(time => {
                    months.push({label: time.description, id: time.id})
                });

                _self.setState({
                    period: months,
                    products: products,
                    product: products[1],
                    month: months[1]
                }, function () {
                    _self.refs.period.update(months[1]);
                    _self.refs.product.update(products[1]);
                    if(_self.props.level === 'STATION'){
                        _self.refs.otherStation.update(_self.state.otherStation);
                    }
                    _self.loadChart();
                });
            });
        });
    }

    getPeriod(item) {
        this.setState({month: item, chartAvailable: false}, function () {
            this.loadChart();
        });
    }

    getProducts(item) {
        this.setState({product: item, chartAvailable: false}, function () {
            this.loadChart();
        });
    }

    getOtherStations(item) {
        this.setState({otherStation: item, chartAvailable: false}, function () {
            this.loadChart();
        });
    };

    redraw() {
        let _self = this;
        if (_self.refs.chart) {
            let chart = _self.refs.chart.getChart();
            let seriesLength = chart.series.length;
            for (let i = seriesLength - 1; i > -1; i--) {
                chart.series[i].remove();
            }

            this.state.series.forEach(serie => {
                chart.addSeries(serie);
            });
        }
    }

    render() {
        let _self = this;
        return <div className="row">
            <Title isOpen={_self.state.opened} toggle={() => {
                _self.setState({strategy: {}, opened: !_self.state.opened}, function () {
                    if (_self.state.opened) _self.componentDidMount();
                });
            }} text="SENSIBILIDAD PRECIO - DEMANDA" isGray={true} hasIcon={true}/>
            {_self.state.opened && <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className={"marketShare" + this.state.loader}>
                            <div className="row">
                                <div className="col s3 no-gutter">
                                    <Dropdown ref="period" text='COMPARATIVA:&nbsp;&nbsp;&nbsp;'
                                              items={this.state.period}
                                              getItem={this.getPeriod}/>
                                </div>
                                <div className="col s3 no-gutter">
                                    <Dropdown ref="product" text='PRODUCTO:' items={this.state.products}
                                              getItem={this.getProducts}/>
                                </div>
                                {this.props.level !== 'STATION' ?
                                <div className="col s6 no-gutter">
                                    <Dropdown text='' noIcon={true} items={[{id: 0, label: "&nbsp;"}]}/>
                                </div>
                                :
                                <div>
                                    <div className="col s3 no-gutter">
                                        <Dropdown ref="otherStation" text='BOCA:' items={this.state.otherStations}
                                                  getItem={this.getOtherStations}/>
                                    </div>
                                    <div className="col s3 no-gutter">
                                        <Dropdown text='' noIcon={true} items={[{id: 0, label: "&nbsp;"}]}/>
                                    </div>
                                </div>
                                }
                            </div>
                            <div className={this.state.chartAvailable ? "" : "loader"}>
                                <div className="chartContainer">
                                    <ReactHighcharts config={this.state.chart} ref="chart"/>
                                </div>
                                <table className="sensibility">
                                    <tbody>
                                    {this.state.rows.map((row, index) => {
                                        return <tr key={index}>
                                            <td>
                                                <span>{row.label}</span>
                                                <i style={{background: row.color, "height": row.height + 'px'}}></i>
                                            </td>
                                            {row.data && row.data.map((value, v) => {
                                                let style = {
                                                    width: (850/ row.data.length) + 'px',
                                                    textAlign:'center',
                                                    paddingLeft:5
                                                };
                                                if ((v + 1) === parseInt(row.data.length / 2, 10)) {
                                                    style.borderRight = '1px solid #e0e0e0';
                                                    style.width = ((850/ row.data.length) ) + 'px'
                                                }

                                                return <td style={style} key={v}>{value !== null ? value : '-'}</td>
                                            })}
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/sensibility.js